import * as React from "react";
import Button from "@mui/material/Button";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FormikField, SelectObjectField } from "../FormFields";
import { BaseModal } from "./BaseModal";
import { useState } from "react";
import { useToast } from "../../context/Toast/ToastProvider";
import { ToastType, showToast } from "../../utils/ToastUtil";
import { useEffect } from "react";
import { useStateAuthValue } from "../../context/AuthState";
import { getPrepaidHealth, getPrepaidHealthCategoryByPrepaidHealth } from "../../services/prepaidHealthService";
import { useRef } from "react";
import { getFinancerPlans, getPatientAdditionalData } from "../../services/patientsService";
import { Skeleton } from "@material-ui/lab";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Typography } from "@mui/material";
import PersonRounded from "@mui/icons-material/PersonRounded";
import { EditRounded } from "@mui/icons-material";
export const SeePatientDetailsModal = ({
  open,
  setOpen,
  handleClose,
  patient,
}) => {
  const FormScheme = Yup.object().shape({
    lastName: Yup.string().required("No debe quedar vacío"),
    firstName: Yup.string().required("No debe quedar vacío"),
    id_number: Yup.string().required("No debe quedar vacío"),
    email: Yup.string()
      .email("Correo inválido")
      .required("No debe quedar vacío"),
    phone: Yup.string().required("No debe quedar vacío"),
    sex: Yup.string().required("No debe quedar vacío"),
  });
  const [prepaidHealthList, setPrepaidHealthList] = useState([]);
  const [prepaidHealth, setPrepaidHealth] = useState("");
  const [prepaidHealthCategoryList, setPrepaidHealthCategoryList] = useState(
    []
  );
  const [prepaidHealthCategory, setPrepaidHealthCategory] = useState("");
  const [emptyPrepaidHealthCategoryList, setEmptyPrepaidHealthCategoryList] =
    useState(false);
  const toastDispatch = useToast();
  const showError = (msgError) => {
    showToast(toastDispatch, msgError, ToastType.ERROR, ToastType.ERROR);
  };
  const [{ userToken }] = useStateAuthValue();
  const formikSetValues = useRef(null);

  const [financerPlansList, setFinancerPlansList] = useState([]);
  const [currentFinancerPlan, setCurrentFinancerPlan] = useState({});
  const sexList = [
    {
      name: `Hombre`,
      id: `MALE`,
    },
    {
      name: `Mujer`,
      id: `FEMALE`,
    },
    {
      name: `No binario`,
      id: `NON_BINARY`,
    },
  ];
  const fetchFinancerPlans = async () => {
    const response = await getFinancerPlans(userToken, showError);
    let _financerPlansList = [];
    //console.log(response);
    response?.data?.map((plan) => {
      if (plan.financerId == "32333636-3631-3338-2d33-3536362d3336") {
        _financerPlansList = [
          ..._financerPlansList,
          {
            name: `${plan.planName}`,
            id: plan.id,
          },
        ];
      }
    });
    let _agreementFinancerPlansList = [];
    response?.data?.map((plan) => {
      if (plan.financerId != "32333636-3631-3338-2d33-3536362d3336") {
        _agreementFinancerPlansList = [
          ..._agreementFinancerPlansList,
          {
            name: `${plan.planName} - ${plan.financer.financerName}`,
            id: plan.id,
          },
        ];
      }
    });
    _agreementFinancerPlansList.sort((a, b) => {
      // Comparamos los nombres en minúsculas para asegurar una comparación insensible a mayúsculas/minúsculas
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if (nameA < nameB) {
        return -1; // nameA debe ir antes que nameB
      }
      if (nameA > nameB) {
        return 1; // nameA debe ir después que nameB
      }
      return 0; // Los nombres son iguales
    });
    _financerPlansList = [
      ..._financerPlansList,
      ..._agreementFinancerPlansList,
    ];
    setFinancerPlansList(_financerPlansList);
  };

  useEffect(() => {
    fetchFinancerPlans();
  }, []);

  const renderExtraLabel = () => {
    if (prepaidHealth) {
      if (emptyPrepaidHealthCategoryList) {
        return "No hay planes para esta obra social";
      } else if (prepaidHealth && !prepaidHealthCategory) {
        return "El plan es requerido";
      } else {
        return "";
      }
    } else {
      return "Seleccioná primero tu obra social";
    }
  };

  const fetchPrepaidHealthCategoryList = async (prepaidHealthSelected) => {
    const response = await getPrepaidHealthCategoryByPrepaidHealth(
      userToken,
      prepaidHealthSelected,
      showError
    );
    setPrepaidHealthCategoryList(response?.data);
    setEmptyPrepaidHealthCategoryList(response?.data?.length === 0);
  };

  const fetchPrepaidHealthList = async () => {
    const response = await getPrepaidHealth(userToken, showError);
    setPrepaidHealthList(response?.data);
  };

  useEffect(() => {
    if (prepaidHealth && prepaidHealth !== "") {
      fetchPrepaidHealthCategoryList(prepaidHealth?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prepaidHealth]);

  useEffect(() => {
    if (prepaidHealth && prepaidHealth !== "") {
      if (prepaidHealth.name === "PARTICULAR") {
        setPrepaidHealthCategory(prepaidHealthCategoryList[0]);
        if (
          formikSetValues?.current !== undefined &&
          typeof formikSetValues.current === "function"
        ) {
          formikSetValues.current((prevValues) => ({
            ...prevValues,
            affiliate_number: "",
          }));
        }
      } else {
        formikSetValues.current((prevValues) => ({
          ...prevValues,
          affiliate_number: patientAdditionalData?.affiliate_number,
        }));
      }
    }
  }, [prepaidHealth, prepaidHealthCategoryList]);

  useEffect(() => {
    if (prepaidHealthCategory || prepaidHealth) {
      const prepaidValues = {
        id: prepaidHealthCategory?.id,
        name: prepaidHealthCategory?.name,
        prepaidHealth: {
          id: prepaidHealth?.id,
          name: prepaidHealth?.name,
        },
      };
      if (
        formikSetValues?.current !== undefined &&
        typeof formikSetValues.current === "function"
      ) {
        formikSetValues.current((prevValues) => ({
          ...prevValues,
          prepaid_health_category: prepaidValues,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prepaidHealthCategory, prepaidHealth]);

  const [lastPatientId, setLastPatientId] = useState(null);
  const [patientAdditionalData, setPatientAdditionalData] = useState(null);
  const [loadingAdditionalData, setLoadingAdditionalData] = useState(false);
  useEffect(() => {
    const getAdditionalData = async () => {
      setLastPatientId(patient.id);
      setLoadingAdditionalData(true);
      await getPatientAdditionalData(userToken, patient.id, patient.product)
        .then((res) => {
          setPatientAdditionalData(res);
        })
        .finally(() => {
          setLoadingAdditionalData(false);
        });
    };
    if (patient != null && lastPatientId != patient.id) getAdditionalData();
  }, [patient]);

  useEffect(() => {
    fetchPrepaidHealthList();
    if (patientAdditionalData?.prepaid_health_category) {
      setPrepaidHealthCategory(
        patientAdditionalData?.prepaid_health_category || ""
      );
      setPrepaidHealth(
        patientAdditionalData?.prepaid_health_category?.prepaidHealth || ""
      );
    } else {
      setPrepaidHealthCategory("");
      setPrepaidHealth("");
    }
  }, [patientAdditionalData]);
  const [currentTab, setCurrentTab] = useState("titular");

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  return (
    <div>
      <BaseModal
        width="720px"
        open={open}
        setOpen={(param) => {
          setOpen(param);
          if (!param) {
            setLastPatientId(null);
            setPatientAdditionalData({});
          }
        }}
      >
        {/* Header de marca (azul) con datos del socio */}
        <Box
          sx={{
            background: "linear-gradient(195deg, #002C54, #003f77)",
            borderRadius: "15px",
            color: "white",
            padding: "1.25rem 1.5rem",
            boxShadow: "0 8px 24px rgba(0,44,84,0.25)",
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            marginBottom: "1.25rem",
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: "12px",
              background: "rgba(255,255,255,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <EditRounded />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
              Editar socio
            </Typography>
            <Typography sx={{ fontSize: "13px", opacity: 0.85 }}>
              {patient?.lastName || patient?.firstName
                ? `${patient?.lastName ?? ""}${
                    patient?.lastName && patient?.firstName ? ", " : ""
                  }${patient?.firstName ?? ""}`
                : "Datos del socio"}
              {patient?.id_number ? ` · DNI ${patient.id_number}` : ""}
            </Typography>
          </Box>
        </Box>

        <Formik
          initialValues={{
            lastName: patient?.lastName || "",
            firstName: patient?.firstName || "",
            email: patient?.email || "",
            id_number: patient?.id_number || "",
            plan_id: patient?.plan_id || "",
            affiliate_number: patient?.affiliate_number || "",
            phone: patient?.phone || "",
            sex: patient?.sex || "",
          }}
          validationSchema={FormScheme}
        >
          {({ isValid, values, setValues }) => {
            formikSetValues.current = setValues;
            return (
              <Form>
                {loadingAdditionalData ? (
                  <>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2,1fr)",
                        gridGap: "25px",
                      }}
                    >
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                      <Skeleton variant="rect" height={60} sx={{ mb: 2 }} />
                    </div>
                  </>
                ) : (
                  <>
                    <TabContext value={currentTab}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList
                          onChange={handleTabChange}
                          aria-label="patient tabs"
                        >
                          <Tab label="Titular" value="titular" />
                          <Tab label="Grupo Familiar" value="family-group" />
                        </TabList>
                      </Box>
                      <TabPanel style={{ padding: "15px" }} value="titular">
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            gridGap: "25px",
                          }}
                        >
                          <FormikField name="lastName" label="Apellido" />
                          <FormikField name="firstName" label="Nombre" />
                          <FormikField name="id_number" label="DNI" disabled={true} />
                          <FormikField name="email" label="Correo" disabled={true} />
                          <FormikField name="phone" label="Celular" />
                          <SelectObjectField
                            label="Plan"
                            setValue={(e) => {
                              console.log(
                                financerPlansList.filter(
                                  (fp) => fp.id == values.plan_id
                                )[0]
                              );
                              setValues({ ...values, plan_id: e.id });
                              //setCurrentFinancerPlan(e);
                            }}
                            value={
                              financerPlansList.filter(
                                (fp) => fp.id == values.plan_id
                              )[0]
                            }
                            data={financerPlansList || []}
                            className="field"
                            //errorMsg={errors.financer_plan}
                            //isError={errors.financer_plan}
                          />
                          <SelectObjectField
                            label="Obra Social o Prepaga"
                            value={prepaidHealth}
                            setValue={(e) => {
                              if (prepaidHealth !== e)
                                setPrepaidHealthCategory("");
                              setPrepaidHealth(e);
                            }}
                            data={prepaidHealthList || []}
                              className="field"
                              disabled="true"
                          />
                          <SelectObjectField
                            label="Plan obra social"
                            defaultValue=""
                            value={prepaidHealthCategory}
                            setValue={setPrepaidHealthCategory}
                            data={prepaidHealthCategoryList || []}
                            className="field"
                            disabled={
                              //!prepaidHealth || emptyPrepaidHealthCategoryList
                              true
                            }
                            extraLabel={renderExtraLabel()}
                          />
                          <FormikField
                            name="affiliate_number"
                            label="N° de asociado"
                            disabled="true"
                          />
                          <SelectObjectField
                            label="Sexo"
                            setValue={(e) => {
                              //console.log(financerPlansList.filter((fp) => fp.id == values.plan_id)[0]);
                              setValues({ ...values, sex: e.id });
                              //setCurrentFinancerPlan(e);
                            }}
                            value={
                              sexList.filter((fp) => fp.id == values.sex)[0]
                            }
                            data={sexList}
                            className="field"
                            //errorMsg={errors.financer_plan}
                            //isError={errors.financer_plan}
                          />
                        </div>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "0.75rem",
                            marginTop: "30px",
                          }}
                        >
                          <Button
                            variant="outlined"
                            sx={{
                              borderRadius: "20px",
                              textTransform: "none",
                              paddingX: "1.5rem",
                              color: "#5a6470",
                              borderColor: "#d4d8dd",
                              "&:hover": {
                                borderColor: "#b9bfc6",
                                background: "#f5f6f8",
                              },
                            }}
                            onClick={() => {
                              setLastPatientId(null);
                              setPatientAdditionalData({});
                              setOpen(false);
                            }}
                          >
                            Cancelar
                          </Button>
                          <Button
                            disabled={
                              !isValid || prepaidHealth === ""
                                ? false
                                : prepaidHealthCategory === ""
                                ? true
                                : prepaidHealth.name === "PARTICULAR"
                                ? false
                                : values.affiliate_number === ""
                                ? true
                                : false
                            }
                            type="submit"
                            variant="contained"
                            sx={{
                              backgroundColor: "#002C54",
                              borderRadius: "20px",
                              textTransform: "none",
                              paddingX: "1.5rem",
                              boxShadow: "0 8px 20px rgba(0,44,84,0.28)",
                              "&:hover": { backgroundColor: "#003F77" },
                            }}
                            onClick={() => {
                              handleClose(values);
                            }}
                          >
                            Guardar cambios
                          </Button>
                        </Box>
                      </TabPanel>
                      <TabPanel
                        style={{ padding: "15px" }}
                        value="family-group"
                      >
                        {patientAdditionalData?.familyPatientBackOffDTOS
                          ?.length ? (
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns:
                                "repeat(auto-fill, minmax(240px, 1fr))",
                              gap: "1rem",
                            }}
                          >
                            {patientAdditionalData.familyPatientBackOffDTOS.map(
                              (fp) => {
                                const sexName = sexList.filter(
                                  (s) => s.id == fp.sex
                                )[0]?.name;
                                return (
                                  <Box
                                    key={fp.id_number}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.85rem",
                                      padding: "1rem",
                                      border: "1px solid #ebebeb",
                                      borderRadius: "14px",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                                      background: "#ffffff",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        flexShrink: 0,
                                        width: 44,
                                        height: 44,
                                        borderRadius: "12px",
                                        background: "rgba(0,44,84,0.1)",
                                        color: "#002C54",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <PersonRounded />
                                    </Box>
                                    <Box sx={{ minWidth: 0 }}>
                                      <Typography
                                        sx={{
                                          fontSize: "0.95rem",
                                          fontWeight: 700,
                                          color: "#002C54",
                                          lineHeight: 1.2,
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {fp.firstName} {fp.lastName}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          fontSize: "0.8rem",
                                          color: "#6b7280",
                                          mt: "2px",
                                        }}
                                      >
                                        DNI {fp.id_number}
                                        {sexName ? ` · ${sexName}` : ""}
                                      </Typography>
                                    </Box>
                                  </Box>
                                );
                              }
                            )}
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "0.5rem",
                              padding: "2.5rem 1rem",
                              color: "#9aa3ad",
                            }}
                          >
                            <PersonRounded sx={{ fontSize: 40, opacity: 0.5 }} />
                            <Typography sx={{ fontSize: "0.9rem" }}>
                              Sin integrantes en el grupo familiar
                            </Typography>
                          </Box>
                        )}
                      </TabPanel>
                    </TabContext>
                  </>
                )}
              </Form>
            );
          }}
        </Formik>
      </BaseModal>
    </div>
  );
};
